import React, { useState } from "react";
import ActivityModule from "@/components/ActivityModule";
import { TrackerTable, PageHeader, Tabs } from "@/components/shared";

const TABS = [
  { id: "activity", label: "Activity & KPIs" },
  { id: "pr-coverage", label: "Media Coverage" },
  { id: "pr-awards", label: "Awards" },
  { id: "pr-appearances", label: "Appearances" },
];

export default function PR() {
  const [active, setActive] = useState("activity");
  return (
    <div>
      <PageHeader title="PR Tracker" subtitle="Daily PR activity → auto KPIs, plus detailed logs" />
      <Tabs tabs={TABS} active={active} onChange={setActive} />
      {active === "activity" ? <ActivityModule module="pr" /> : <TrackerTable id={active} />}
    </div>
  );
}
